import {API_URL_STORE} from "./urls";
// import { idGenerator } from "@/services/idGenerator";

// GET requests

const getCartApi = () => {
  return window.axios

    .get(API_URL_STORE + "cart/v1/get")

    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        const cart = data.responseEntity;

        return cart;
      }

      throw new Error(data.message);
    })

    .catch((error) => {
      throw error;
    });
};

// POST requests

const updateCartItemsApi = (cart) => {
  const items = cart.map((item) => {
    return {
      priceId: item.priceId,
      quantity: item.quantity,
      ready2Order: item.ready2Order,
    };
  });

  return window.axios
    .post(API_URL_STORE + "cart/item/batch/v1/createOrUpdate", {
      requestBodyDto: {
        cartItemList: items,
      },
    })
    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        return data.responseEntity;
      }

      throw new Error(data.message);
    })
    .catch((error) => {
      throw error;
    });
};

const createOrderApi = ({
  details,
  deliveryPoint,
  comment,
  paymentSystemCode,
}) => {
  return window.axios
    .post(API_URL_STORE + "order/v1/createOrUpdate", {
      requestBodyDto: {
        deliveryCode: deliveryPoint.code,
        orderNote: comment,
        paymentSystemCode,
        contactDto: {
          ...details,
        },
      },
    })

    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        return data.responseEntity.orderNum;
      }

      throw new Error(data);
    })
    .catch((error) => {
      throw error;
    });
};

const createOrderAnonApi = ({
  details,
  deliveryPoint,
  comment,
  paymentSystemCode,
  orderItems,
  googleResponseToken,
}) => {
  return window.axios
    .post(API_URL_STORE + "order/anon/v1/create", {
      requestBodyDto: {
        deliveryPoint: {
          ...deliveryPoint,
        },
        orderNote: comment,
        paymentSystemCode,
        contact: {
          ...details,
        },
        orderItems,
        googleResponseToken,
      },
    })

    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        return data.responseEntity;
      }

      throw new Error(data);
    })
    .catch((error) => {
      throw error;
    });
};

const updateOrderApi = ({ orderNum, details, deliveryPoint, comment }) => {
  return window.axios
    .post(API_URL_STORE + "order/v1/createOrUpdate", {
      requestBodyDto: {
        deliveryCode: deliveryPoint,
        orderNote: comment,
        contactDto: {
          ...details,
        },
        orderNum,
      },
    })

    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        return data.requestBodyDto;
      }

      throw new Error(data.message);
    })
    .catch((error) => {
      throw error;
    });
};

export {
  getCartApi,
  updateCartItemsApi,
  createOrderApi,
  updateOrderApi,
  createOrderAnonApi,
};
